module.exports = __webpack_public_path__ + "static/media/tournament-builder-icon.c2900876.png";